import type {GetUserApiArg} from '../services/rest'

export const currentUserArg: GetUserApiArg = {
  userLocator: 'current',
  fields: 'id,name,username,properties(property),avatars,email',
}
